var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountPropertySection',_vm._b({attrs:{"placeholder":_vm.t('settings', 'Your full name'),"is-editable":_vm.displayNameChangeSupported,"on-validate":_vm.onValidate,"on-save":_vm.onSave}},'AccountPropertySection',_vm.displayName,false,true))
}
var staticRenderFns = []

export { render, staticRenderFns }